export const personalInfo = {
  title: "Thanos eShop",
  brand: "Thanos",
  organization: "Thanos eShop",
  hotline: "01799361381",
};
export const contactInfo = [
  {
    title: "Whatsapp",
    link: "https://wa.me/8801833534123",
    textclass: "text-green-700",
    bgclass: "bg-green-700",
  },
  {
    title: "Telegram",
    link: "https://t.me/+CFfZ5i8iLB82MTA1",
    textclass: "text-cyan-600",
    bgclass: "bg-cyan-600",
  },
  {
    title: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100009118447983",
    textclass: "text-blue-700",
    bgclass: "bg-blue-700 ",
  },
];
